import React,{ useState, useEffect } from 'react';

import {
    GoogleReCaptchaProvider
} from 'react-google-recaptcha-v3';

import MovingForm from './MovingForm';

const siteDomain = headerVars.siteDomain;

function Moving() {
    const captchaKey = "6LdmP8QkAAAAACX1XkPWEZ08HGoIkk1nClZiagMJ";
    const [formMarkup, setFormMarkup] = useState(<></>);

    useEffect(() => {
        setTimeout( function(){
            setFormMarkup(
                <div className=''>
                    <GoogleReCaptchaProvider
                        reCaptchaKey={ captchaKey }>
                        <MovingForm />
                    </GoogleReCaptchaProvider>
                </div>
            );
        }, 1000 );
    }, []);

    return (
        <div className="react-contact-form react-moving-form">
            <h1 style={{ marginTop:"0" }}>Are you moving soon?</h1>
            <p style={{ textAlign: "center", margin:"0" }}>Fill out this form and an agent will contact you to confirm the<br/>reconnection of your services.</p>
           
            <div className='contact-form-content-container'>
                { formMarkup }
            </div>
        </div>
    )
}

export default Moving
